// export const SHOP_API_BASE_URL = 'http://ec2-13-234-114-59.ap-south-1.compute.amazonaws.com:1026/api';
export const SHOP_API_BASE_URL = process.env.REACT_APP_SHOP_API_BASE_URL; // 'http://ec2-13-235-245-143.ap-south-1.compute.amazonaws.com:1026/api';
// export const SECURE_API_BASE_URL = 'http://ec2-13-234-114-59.ap-south-1.compute.amazonaws.com:1027/api';
export const SECURE_API_BASE_URL = process.env.REACT_APP_SECURE_API_BASE_URL; //'http://ec2-13-235-245-143.ap-south-1.compute.amazonaws.com:1027/api';

export const COMPARE_PRODUCTS = `${SHOP_API_BASE_URL}/products/compare-products/`;
export const SEARCH_PRODUCTS = `${SHOP_API_BASE_URL}/products/search-products/`;
export const SEARCH_PRODUCTS_BY_NAME = `${SHOP_API_BASE_URL}/products/search-by-name/`;
export const SEARCH_PRODUCTS_BY_CATEGORY = `${SHOP_API_BASE_URL}/products/search-by-category/`;
export const GET_PRODUCT_SUGGESTIONS = `${SHOP_API_BASE_URL}/products/get-suggestions/`;
export const GET_PRODUCT_BY_ID = `${SHOP_API_BASE_URL}/products/get-by-id/`;
export const GET_SERVICE_AVAILABILITY = `${SHOP_API_BASE_URL}/product-logistics`;
export const GET_FILTERS = `${SHOP_API_BASE_URL}/products/get-filters`;

export const GET_LAYOUTS = `${SHOP_API_BASE_URL}/layouts`;
export const GET_CATEGORY_HIERARCHY = `${SHOP_API_BASE_URL}/categories/get-category-hierarchy`;
export const GET_BREADCRUMBS = `${SHOP_API_BASE_URL}/breadcrumbs/get-bread-crumbs/`;

export const GET_OTP = `${SECURE_API_BASE_URL}/login/send-otp`
export const VERIFY_OTP = `${SECURE_API_BASE_URL}/login/sign-in`
export const SIGN_UP = `${SECURE_API_BASE_URL}/login/sign-up`
export const SIGN_IN_WITH_GOOGLE_AUTH = `${SECURE_API_BASE_URL}/login/sign-in/by-google-auth`;
export const RESEND_OTP = `${SECURE_API_BASE_URL}/login/resend-otp/`;

export const GET_PRODUCT_REVIEWS_BY_PRODUCT1 = `${SECURE_API_BASE_URL}/product-reviews/get-reviews-by-product/`;
export const GET_PRODUCT_REVIEWS_BY_PRODUCT = `${SHOP_API_BASE_URL}/products/get-product-reviews/`;
export const PRODUCT_REVIEW = `${SECURE_API_BASE_URL}/product-reviews`;

export const GET_PRODUCT_PROMOTIONS = `${SHOP_API_BASE_URL}/promotions?`;

export const ORDER = `${SECURE_API_BASE_URL}/orders`;
export const GET_ORDERS_BY_CUSTOMER = `${SECURE_API_BASE_URL}/orders/customer/`;
export const GET_ORDER_BY_ID = `${SECURE_API_BASE_URL}/orders/`;

export const CUSTOMERS = `${SECURE_API_BASE_URL}/customers`;
export const GET_CURRENT_CUSTOMER = `${SECURE_API_BASE_URL}/customers/me`;

export const CART = `${SECURE_API_BASE_URL}/carts`;
export const GET_CART_BY_SESSION = `${SECURE_API_BASE_URL}/carts/session/`;
export const GET_CART_BY_CUSTOMER = `${SECURE_API_BASE_URL}/carts/customer/`;
export const REMOVE_CART_ITEM = `${SECURE_API_BASE_URL}/carts/customer/`;
export const ADD_CART_ITEM = `${SECURE_API_BASE_URL}/carts/customer/`;

export const ADDRESS = `${SECURE_API_BASE_URL}/address`;

export const CREATE_PAYMENT_WEBHOOK = `${SECURE_API_BASE_URL}/payments/webhook`;
export const CREATE_NEW_PAYMENT_WEBHOOK = `${SECURE_API_BASE_URL}/payments/webhook-new`;
export const CREATE_PAYMENT_ORDER = `${SECURE_API_BASE_URL}/payments/createOrder`;